/**
 * Resolve URL de logo do fornecedor.
 * Preferência: imageThumb → image. Aceita data: e https: (legado + Storage).
 */

export type SupplierImageCarrier = {
  image?: string | null;
  imageThumb?: string | null;
};

function isUsableUrl(value: unknown): value is string {
  if (typeof value !== 'string') return false;
  const v = value.trim();
  if (!v || v === 'undefined' || v === 'null') return false;
  if (v.startsWith('data:image/') || v.startsWith('data:')) return true;
  if (v.startsWith('https://') || v.startsWith('http://')) return true;
  if (v.startsWith('blob:') || v.startsWith('/')) return true;
  return false;
}

/** Card/listas: thumb primeiro. Detalhe/capa: image primeiro. */
export function resolveSupplierImage(
  supplier: SupplierImageCarrier | null | undefined,
  variant: 'card' | 'detail' = 'card',
  fallback = ''
): string {
  if (!supplier) return fallback;

  const card = [supplier.imageThumb, supplier.image];
  const detail = [supplier.image, supplier.imageThumb];
  const candidates = variant === 'card' ? card : detail;

  for (const c of candidates) {
    if (isUsableUrl(c)) return c.trim();
  }
  return fallback;
}
